export default __webpack_public_path__ + "static/media/vod-big.7fdb73e0.jpg";